import Vue from 'vue'
import { WordpressState , RootState } from '@/store/state_models'
import { Module, ActionContext } from 'vuex'
import WordpressService from '../services/WordpressService'


function getInitialData(): WordpressState {
  return {
    productName : 'WORDPRESS_V1',
    resellingProduct: {} as object,
    isOfferingEnabled: false,
    hasFetchedOfferingEnabled : false
  }
}

export const wordpress: Module<WordpressState, RootState> = {
  namespaced: true,
  state: getInitialData(),
  getters: {
    getProductName: (state: WordpressState) => {
      return state?.productName
    },
    isWordPressOfferingEnabled: (state: WordpressState) => {
      return {
        isOfferingEnabled: state.isOfferingEnabled,
        hasFetchedOfferingEnabled: state.hasFetchedOfferingEnabled
      }
    }
  },
  mutations: {
    setOfferingEnabled: (state: WordpressState, value: boolean) => {
      state.isOfferingEnabled = value
      state.hasFetchedOfferingEnabled = true
    },
  },
  actions: {
    fetchOfferingEnabled: {
      handler : (context: ActionContext<WordpressState, RootState>, locationId: string) => {
        if(locationId) {
          return new Promise(async (resolve, reject) => {
              if (context.state.hasFetchedOfferingEnabled) {
              return resolve(context.state.isOfferingEnabled)
            }
            try {
              const res = await WordpressService.Payment.getLocationConfig(locationId)
              if (res.data) {
                context.commit('setOfferingEnabled', res.data.offeringEnabled)
              }
              resolve(res.data)
            } catch (error) {
              reject(error)
            }
          });
        }
      },
    },
    getWordpressDetails: async (state:WordpressState,  payload: object) => {
      return  (await WordpressService.Common.getWordpressByLocId(payload.locationId)).data
    },
    getLocationConfig: async (state:WordpressState,  payload: object) => {
      return  (await WordpressService.Payment.getLocationConfig(payload.locationId)).data
    },
    getCompanyConfig: async (state:WordpressState,  payload: object) => {
      return  (await WordpressService.Payment.getCompanyConfig(payload.companyId)).data
    },
    getCompanySubscriptions: async (state:WordpressState,  payload: object) => {
      return  (await WordpressService.Payment.getCompanySubscriptions(payload.companyId)).data
    },
    //getProduct: async () => {
    //  return (await WordpressService.Payment.getProduct()).data
    //}
    getProduct: async (context: ActionContext<WordpressState, RootState>) => {
      const companyId = context.rootState?.company.company.id as string
      return (await WordpressService.Payment.getProduct(companyId)).data
    }
  },
}
